import BindingsHandler from './BindingsHandler';
import Console from './Console';
const  console = Console;
export default function enableAcceptBindings(model){
	if(model.bindingsHandler)return model.bindingsHandler
	model.bindingsHandler = new BindingsHandler(model);
	return model.bindingsHandler;
};